module.exports = __webpack_public_path__ + "img/minus_grey.bc742880.svg";